module.exports = __webpack_public_path__ + "img/11.58.17.a78b8a77.jpeg";